//Async Storage Keys
const ACCESS_TOKENS = 'ACCESS_TOKENS'

const SELECT_BOARD='SELECT_BOARD'

export {ACCESS_TOKENS,SELECT_BOARD}
